export default {
  "user": {
    "personal-center": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个人中心"])},
    "control": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户与访问控制"])},
    "setting": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["平台设置"])},
    "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退出登录"])},
    "subAccount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["子账号"])}
  },
  "feedback": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["建议反馈"])},
  "help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["帮助文档"])},
  "messages": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消息盒子"])},
  "count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["消息数量"])}
}